import { createSelector } from 'reselect';
import { START_MESSAGE_TAG } from '../models/Constants';
import { MessageType } from '../models/messages/enums/MessageType';
import { IApplicationState } from "./../../../../../src/~store/models/ApplicationState";

const chatStateSelector = (state: IApplicationState) => state.chat;

export const messagesSelector = createSelector(
    chatStateSelector,
    chatItems => chatItems.messages.filter(m => !chatItems.hideClientStartMessage || m.tag !== START_MESSAGE_TAG).sort((a, b) => 
        {
            return new Date(a.timeSent).getTime() - new Date(b.timeSent).getTime()
        }
    )
);

export const isMessageEditingSelector = createSelector(
    chatStateSelector,
    chatState => chatState.isMessageEditing,
);

export const isGettingPrevChatMessagesSelector = createSelector(
    chatStateSelector,
    chatState => chatState.isGettingPrevChatMessages,
);

export const firstUnreadMessageSelector = createSelector(
    chatStateSelector,
    chatState => chatState.messages.filter(m => m.isRead === false && m.messageType !== MessageType.ClientMessage)[0]
);

export const sendingFilesCountSelector = createSelector(
    chatStateSelector,
    chatState => chatState.sendingFilesCount
    
);

export const companyNameSelector = createSelector(
    chatStateSelector,
    chatState => chatState.footerCompanyName
);

export const companyUrlSelector = createSelector(
    chatStateSelector,
    chatState => chatState.footerCompanyUrl
);


export const customerIdSelector = createSelector(
    chatStateSelector,
    chatState => chatState.customerId
);

export const loadPrevChatSelector = createSelector(
    chatStateSelector,
    chatState => chatState.loadPrevChat
);

export const sendingMessageSelector = createSelector(
    chatStateSelector,
    chatState => chatState.sendingMessage
);